'use strict';

module.exports = function (from, to) {
  var transition = {
    from: from,
    to: to,
    hasChanged: function hasChanged(selector) {
      return selector(from) !== selector(to);
    },
    hasChangedToMatch: function hasChangedToMatch(selector, predicate) {
      return transition.hasChanged(selector) && predicate(selector(to));
    },
    hasChangedToTrue: function hasChangedToTrue(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ === true;
      });
    },
    hasChangedToFalse: function hasChangedToFalse(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ === false;
      });
    },
    hasChangedToNull: function hasChangedToNull(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ === null;
      });
    },
    hasChangedToNotNull: function hasChangedToNotNull(selector) {
      return transition.hasChangedToMatch(selector, function (_) {
        return _ !== null;
      });
    }
  };

  return transition;
};